import { render, staticRenderFns } from "./xac-minh-nhan-su.vue?vue&type=template&id=79879b49"
import script from "./xac-minh-nhan-su.vue?vue&type=script&lang=js"
export * from "./xac-minh-nhan-su.vue?vue&type=script&lang=js"
import style0 from "./xac-minh-nhan-su.vue?vue&type=style&index=0&id=79879b49&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports